// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mounted into .appnav (public/css/index.css), which is position:fixed with a fixed height and
 * its own overflow:auto — hand full height to this flex column so its internal section list
 * scrolls independently instead of the whole sidebar scrolling as one block. */
.appnav.r-seller-nav-sidebar {
  overflow: hidden;
}

.appnav.r-seller-nav-sidebar > .seller-nav-sidebar {
  height: 100%;
}

/**
 * Palette matches ul.appnav in public/css/index.css: the sidebar is deliberately the same dark
 * green in both light and dark themes, so these are literal values rather than --color-* tokens.
 * \`.seller-nav-sidebar--red\` (set by SellerNavSidebar.jsx when \`channel.isRed\`) overrides these to the
 * dashboard_red.css palette below, including its own [data-theme="dark"] variant.
 */
.seller-nav-sidebar {
  --seller-nav-bg: #263934;
  --seller-nav-bg-deep: #1d2e23;
  --seller-nav-bg-panel: #21322d;
  --seller-nav-accent: #74bb50;
  --seller-nav-accent-rgb: 116, 187, 80;
  --seller-nav-text: #fff;
  --seller-nav-text-secondary: rgba(255, 255, 255, 0.62);
  --seller-nav-border: rgba(255, 255, 255, 0.09);

  display: flex;
  flex-direction: column;
  background: var(--seller-nav-bg);
  color: var(--seller-nav-text);
  font-size: 14px;
  line-height: 1.4;
}

/* Mayhem Red: mirrors public/css/dashboard_red.css's ul.appnav overrides (light and dark). */
.seller-nav-sidebar--red {
  --seller-nav-bg: #300900;
  --seller-nav-bg-deep: #4e0f00;
  --seller-nav-bg-panel: #3d0c00;
  --seller-nav-accent: #ca1e00;
  --seller-nav-accent-rgb: 202, 30, 0;
}

[data-theme='dark'] .seller-nav-sidebar--red {
  --seller-nav-bg: #1a0500;
  --seller-nav-bg-deep: #7a2000;
  --seller-nav-bg-panel: #401200;
  --seller-nav-accent: #7a2000;
  --seller-nav-accent-rgb: 122, 32, 0;
}

.seller-nav-sidebar--loading {
  padding: 1rem;
  color: var(--seller-nav-text-secondary);
}

.seller-nav-sidebar a {
  color: inherit;
  text-decoration: none;
}

.seller-nav-sidebar :focus-visible {
  outline: 2px solid var(--seller-nav-accent);
  outline-offset: -2px;
}

/* Channel switcher */

.seller-nav-sidebar__channel-switcher {
  position: relative;
  border-bottom: 1px solid var(--seller-nav-border);
}

.seller-nav-sidebar__channel-switcher-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 0.5rem;
  padding: 0.9rem 1rem;
  background: transparent;
  border: none;
  cursor: pointer;
  color: inherit;
  font: inherit;
  font-weight: 600;
  text-align: left;
}

.seller-nav-sidebar__channel-switcher-toggle:hover {
  background: var(--seller-nav-accent);
}

.seller-nav-sidebar__channel-switcher-current {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex: 1;
  min-width: 0;
}

.seller-nav-sidebar__channel-switcher-avatar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 4px;
  background: var(--seller-nav-bg-deep);
  color: var(--seller-nav-accent);
}

.seller-nav-sidebar__channel-switcher-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.seller-nav-sidebar__channel-switcher-arrow {
  flex-shrink: 0;
  transition: transform 0.2s;
}

.seller-nav-sidebar__channel-switcher-toggle[aria-expanded='true'] .seller-nav-sidebar__channel-switcher-arrow {
  transform: rotate(180deg);
}

.seller-nav-sidebar__channel-switcher-panel {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  max-height: 300px;
  overflow-y: auto;
  background: var(--seller-nav-bg-deep);
  border-bottom: 1px solid var(--seller-nav-border);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.35);
}

.seller-nav-sidebar__channel-switcher-group-label {
  padding: 0.7rem 1rem 0.35rem;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--seller-nav-text-secondary);
}

.seller-nav-sidebar__channel-switcher-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.seller-nav-sidebar__channel-switcher-list li {
  margin: 0;
  padding: 0;
}

.seller-nav-sidebar__channel-switcher-list a {
  display: block;
  padding: 0.5rem 1rem;
}

.seller-nav-sidebar__channel-switcher-list a:hover {
  background: var(--seller-nav-accent);
}

.seller-nav-sidebar__channel-switcher-loading,
.seller-nav-sidebar__channel-switcher-empty {
  padding: 1rem;
  text-align: center;
  font-size: 13px;
  color: var(--seller-nav-text-secondary);
}

/* Search */

.seller-nav-sidebar__search {
  position: relative;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--seller-nav-border);
}

.seller-nav-sidebar__search-input {
  width: 100%;
  padding: 0.5rem 0.65rem;
  border: 1px solid var(--seller-nav-border);
  border-radius: 4px;
  font: inherit;
  background: var(--seller-nav-bg-deep);
  color: var(--seller-nav-text);
}

.seller-nav-sidebar__search-input:focus {
  outline: none;
  border-color: var(--seller-nav-accent);
  box-shadow: 0 0 0 2px rgba(var(--seller-nav-accent-rgb), 0.28);
}

.seller-nav-sidebar__search-input::placeholder {
  color: var(--seller-nav-text-secondary);
}

.seller-nav-sidebar__search-result-count {
  position: absolute;
  top: 1.4rem;
  right: 1.6rem;
  font-size: 11px;
  color: var(--seller-nav-text-secondary);
  pointer-events: none;
}

/* Help articles search widget */

.seller-nav-help-articles {
  border-bottom: 1px solid var(--seller-nav-border);
  background: var(--seller-nav-bg-panel);
}

.seller-nav-help-articles__header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem 0.4rem;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--seller-nav-text-secondary);
  border-bottom: 1px solid var(--seller-nav-border);
}

.seller-nav-help-articles__icon {
  color: var(--seller-nav-accent);
  font-size: 12px;
}

.seller-nav-help-articles__loading-indicator {
  margin-left: auto;
  font-size: 14px;
  line-height: 1;
  color: var(--seller-nav-accent);
}

.seller-nav-help-articles__status {
  padding: 0.6rem 1rem;
  font-size: 12px;
  color: var(--seller-nav-text-secondary);
  font-style: italic;
}

.seller-nav-help-articles__status--error {
  color: #e57373;
}

.seller-nav-help-articles__list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.seller-nav-help-articles__item {
  margin: 0;
  padding: 0;
  border-bottom: 1px solid var(--seller-nav-border);
}

.seller-nav-help-articles__item:last-child {
  border-bottom: none;
}

.seller-nav-help-articles__link {
  display: block;
  padding: 0.55rem 1rem;
  text-decoration: none;
  color: inherit;
  transition: background-color 0.15s ease;
}

.seller-nav-help-articles__link:hover {
  background: var(--seller-nav-accent);
  color: var(--seller-nav-text);
}

.seller-nav-help-articles__item-title {
  display: block;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  color: var(--seller-nav-text);
}

.seller-nav-help-articles__link:hover .seller-nav-help-articles__item-title {
  color: var(--seller-nav-text);
}

.seller-nav-help-articles__item-subtitle {
  display: block;
  font-size: 11px;
  line-height: 1.35;
  color: var(--seller-nav-text-secondary);
  margin-top: 0.15rem;
}

.seller-nav-help-articles__link:hover .seller-nav-help-articles__item-subtitle {
  color: rgba(255, 255, 255, 0.85);
}

/* Sections */

.seller-nav-sidebar__sections {
  flex: 1;
  overflow-y: auto;
}

/**
 * A pinned section renders SellerNavItem rows directly, with no accordion header. They sit at
 * the sidebar's top level, so they're restyled to read as peers of the section headers rather
 * than as items nested inside one: sidebar ground, accent icon, heavier title.
 */
.seller-nav-sidebar__pinned {
  list-style: none;
  margin: 0;
  padding: 0;
  background: var(--seller-nav-bg);
  border-bottom: 1px solid var(--seller-nav-border);
}

.seller-nav-sidebar__pinned .seller-nav-item {
  border-top: none;
}

.seller-nav-sidebar__pinned .seller-nav-item__link {
  padding: 0.75rem 1rem;
}

.seller-nav-sidebar__pinned .seller-nav-item__icon {
  width: 20px;
  color: var(--seller-nav-accent);
}

.seller-nav-sidebar__pinned .seller-nav-item__row:hover .seller-nav-item__icon {
  color: var(--seller-nav-text);
}

.seller-nav-sidebar__pinned .seller-nav-item__text strong {
  font-weight: 600;
}

.seller-nav-section {
  border-bottom: 1px solid var(--seller-nav-border);
}

.seller-nav-section__toggle {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background: transparent;
  border: none;
  border-left: 3px solid transparent;
  cursor: pointer;
  color: inherit;
  font: inherit;
  font-weight: 600;
  text-align: left;
}

.seller-nav-section__toggle:hover {
  background: var(--seller-nav-accent);
}

.seller-nav-section--expanded .seller-nav-section__toggle {
  background: var(--seller-nav-bg-deep);
}

.seller-nav-section--active-trail .seller-nav-section__toggle {
  border-left-color: var(--seller-nav-accent);
}

.seller-nav-section__icon {
  flex-shrink: 0;
  width: 20px;
  text-align: center;
  color: var(--seller-nav-accent);
}

.seller-nav-section__toggle:hover .seller-nav-section__icon {
  color: var(--seller-nav-text);
}

.seller-nav-section__title {
  flex: 1;
  min-width: 0;
}

.seller-nav-section__alert-indicator {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f4c542;
  box-shadow: 0 0 0 2px rgba(244, 197, 66, 0.18);
}

.seller-nav-section__chevron {
  flex-shrink: 0;
  font-size: 12px;
  color: var(--seller-nav-text-secondary);
  transition: transform 0.2s;
}

.seller-nav-section--expanded .seller-nav-section__chevron {
  transform: rotate(180deg);
}

.seller-nav-section__items {
  background: var(--seller-nav-bg-panel);
}

.seller-nav-section__list {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Items */

.seller-nav-item {
  margin: 0;
  padding: 0;
  list-style: none;
  border-top: 1px solid var(--seller-nav-border);
}

.seller-nav-item__row {
  display: flex;
  align-items: stretch;
  border-left: 3px solid transparent;
}

.seller-nav-item--active > .seller-nav-item__row {
  background: var(--seller-nav-bg-deep);
  border-left-color: var(--seller-nav-accent);
}

.seller-nav-item__link {
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: flex-start;
  gap: 0.7rem;
  padding: 0.6rem 1rem;
}

.seller-nav-item__row:hover {
  background: var(--seller-nav-accent);
}

.seller-nav-item__icon {
  flex-shrink: 0;
  width: 18px;
  text-align: center;
  margin-top: 2px;
  color: var(--seller-nav-text-secondary);
}

.seller-nav-item__row:hover .seller-nav-item__icon,
.seller-nav-item--active .seller-nav-item__icon {
  color: var(--seller-nav-text);
}

.seller-nav-item__text {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 0.15rem;
}

.seller-nav-item__text strong {
  font-weight: 500;
}

.seller-nav-item__title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.seller-nav-item__count-badge {
  flex-shrink: 0;
  min-width: 1.35rem;
  padding: 0.05rem 0.35rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  color: var(--seller-nav-text);
  font-size: 11px;
  font-weight: 700;
  line-height: 1.35;
  text-align: center;
}

.seller-nav-item__count-badge--updated {
  background: #f4c542;
  color: #1d2e23;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.35;
  text-align: center;
}

.seller-nav-item__description {
  font-size: 12px;
  line-height: 1.35;
  color: var(--seller-nav-text-secondary);
}

.seller-nav-item__row:hover .seller-nav-item__description {
  color: rgba(255, 255, 255, 0.85);
}

.seller-nav-item__disclosure {
  flex-shrink: 0;
  width: 34px;
  background: transparent;
  border: none;
  border-left: 1px solid var(--seller-nav-border);
  color: var(--seller-nav-text-secondary);
  cursor: pointer;
  font-size: 12px;
}

.seller-nav-item__disclosure:hover {
  color: var(--seller-nav-text);
}

.seller-nav-item__disclosure i {
  display: inline-block;
  transition: transform 0.2s;
}

.seller-nav-item__disclosure[aria-expanded='true'] i {
  transform: rotate(180deg);
}

/* Children */

.seller-nav-item__children,
.seller-nav-item__contextual-notes {
  list-style: none;
  margin: 0;
  padding: 0.15rem 0 0.4rem 2.1rem;
  background: var(--seller-nav-bg-deep);
}

.seller-nav-item__child {
  margin: 0;
  padding: 0;
  border-left: 2px solid var(--seller-nav-border);
}

.seller-nav-item__child--active {
  border-left-color: var(--seller-nav-accent);
  background: rgba(var(--seller-nav-accent-rgb), 0.14);
}

.seller-nav-item__child--dimmed {
  opacity: 0.45;
}

.seller-nav-item__child-link {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  padding: 0.4rem 1rem 0.4rem 0.7rem;
}

.seller-nav-item__child-link:hover {
  background: var(--seller-nav-accent);
}

.seller-nav-item__child-icon {
  flex-shrink: 0;
  width: 16px;
  margin-top: 2px;
  text-align: center;
  font-size: 12px;
  color: var(--seller-nav-text-secondary);
}

.seller-nav-item__child-link:hover .seller-nav-item__child-icon {
  color: var(--seller-nav-text);
}

.seller-nav-item__child-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 0.1rem;
}

.seller-nav-item__child-text strong {
  font-size: 13px;
  font-weight: 500;
}

.seller-nav-item__child-description {
  font-size: 11px;
  line-height: 1.35;
  color: var(--seller-nav-text-secondary);
}

.seller-nav-item__child-link:hover .seller-nav-item__child-description {
  color: rgba(255, 255, 255, 0.85);
}

.seller-nav-item__contextual-note {
  margin: 0;
  padding: 0;
}

.seller-nav-item__contextual-note span {
  display: block;
  padding: 0.3rem 1rem 0.3rem 0.7rem;
  font-size: 12px;
  color: var(--seller-nav-text-secondary);
  cursor: not-allowed;
  opacity: 0.8;
}

.seller-nav-sidebar mark {
  background: var(--seller-nav-accent);
  color: var(--seller-nav-bg-deep);
  padding: 0 2px;
  border-radius: 2px;
}

/* Footer controls */

.seller-nav-sidebar__footer {
  display: flex;
  border-top: 1px solid var(--seller-nav-border);
  background: var(--seller-nav-bg-deep);
}

/* Equal thirds, each stacking icon over label so all three fit on one row. */
.seller-nav-sidebar__footer-control {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 0.3rem;
  padding: 0.6rem 0.35rem;
  background: transparent;
  border: none;
  border-left: 1px solid var(--seller-nav-border);
  color: inherit;
  font: inherit;
  text-align: center;
}

.seller-nav-sidebar__footer-control:first-child {
  border-left: none;
}

button.seller-nav-sidebar__footer-control,
a.seller-nav-sidebar__footer-control {
  cursor: pointer;
}

button.seller-nav-sidebar__footer-control:hover,
a.seller-nav-sidebar__footer-control:hover {
  background: var(--seller-nav-accent);
}

/**
 * The icon and label bands are fixed-height and center their contents, so all three cells share
 * a baseline regardless of what fills them: FontAwesome glyphs differ in height, and the
 * language <select> is a bordered box while its neighbors are bare text.
 */
.seller-nav-sidebar__footer-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  font-size: 14px;
  line-height: 1;
  color: var(--seller-nav-text-secondary);
}

button.seller-nav-sidebar__footer-control:hover .seller-nav-sidebar__footer-icon,
a.seller-nav-sidebar__footer-control:hover .seller-nav-sidebar__footer-icon {
  color: var(--seller-nav-text);
}

.seller-nav-sidebar__footer-label {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  font-size: 11px;
  line-height: 1.2;
}

/* Not flex-centered: a <select>'s text is laid out by the browser, which centers it within an
   explicit height once the vertical padding is out of the way. */
.seller-nav-sidebar__footer-select {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  height: 22px;
  padding: 0 0.15rem;
  border: 1px solid var(--seller-nav-border);
  border-radius: 3px;
  background: var(--seller-nav-bg);
  color: var(--seller-nav-text);
  font: inherit;
  font-size: 11px;
  line-height: 1.2;
  text-align: center;
}

.seller-nav-sidebar__footer-select:disabled {
  cursor: not-allowed;
  opacity: 0.75;
}

/**
 * "Minimize Menu" closes the shared .appnav mobile drawer (see closeMobileNav() in
 * SellerNavFooter.jsx) and replaces the legacy .sidebar-launcher hamburger as the close
 * affordance while the drawer is open. It only makes sense on the same mobile drawer layout as
 * public/css/index.css's \`.appnav\` rules, so it stays hidden until that breakpoint (800px) and is
 * otherwise invisible on desktop, where the sidebar is always open and pinned.
 */
.seller-nav-sidebar__footer-minimize {
  display: none;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.55rem 0.5rem;
  background: transparent;
  border: none;
  border-top: 1px solid var(--seller-nav-border);
  color: var(--seller-nav-text-secondary);
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}

.seller-nav-sidebar__footer-minimize:hover {
  background: var(--seller-nav-accent);
  color: var(--seller-nav-text);
}

@media screen and (max-width: 800px) {
  .seller-nav-sidebar__footer-minimize {
    display: flex;
  }

  /* public/css/index.css reserves 100px of bottom padding on \`.appnav\` (and \`ul.helpnav\`) in the
     mobile drawer so the floating .sidebar-launcher button doesn't overlap the last nav link.
     The seller sidebar has its own in-drawer footer ending in the minimize control instead, so
     that reserved space just reads as dead space below it. Collapse it back to 0, scoped to
     .r-seller-nav-sidebar (this component's mount point) so ul.helpnav and any non-React .appnav
     fallback keep their original padding. */
  .appnav.r-seller-nav-sidebar {
    padding-bottom: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Nav/SellerNav.css"],"names":[],"mappings":"AAAA;;+EAE+E;AAC/E;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;EAKE;AACF;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,qCAAqC;EACrC,uBAAuB;EACvB,sDAAsD;EACtD,8CAA8C;;EAE9C,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA,6FAA6F;AAC7F;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA,qBAAqB;;AAErB;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,uCAAuC;AACzC;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,8DAA8D;AAChE;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;EACf,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA,gCAAgC;;AAEhC;EACE,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uCAAuC;EACvC,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,aAAa;;AAEb;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;;;;EAIE;AACF;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA,UAAU;;AAEV;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,uCAAuC;AACzC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,qCAAqC;EACrC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,+CAA+C;EAC/C,uCAAuC;EACvC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,aAAa;;AAEb;;EAEE,gBAAgB;EAChB,SAAS;EACT,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,2CAA2C;EAC3C,oDAAoD;AACtD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,cAAc;EACd,kBAAkB;AACpB;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,+CAA+C;EAC/C,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;;;EAIE;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,uCAAuC;AACzC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;iEACiE;AACjE;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,gCAAgC;EAChC,6BAA6B;EAC7B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;;;;;;EAME;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,8CAA8C;EAC9C,uCAAuC;EACvC,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;;;;4CAK0C;EAC1C;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Mounted into .appnav (public/css/index.css), which is position:fixed with a fixed height and\n * its own overflow:auto — hand full height to this flex column so its internal section list\n * scrolls independently instead of the whole sidebar scrolling as one block. */\n.appnav.r-seller-nav-sidebar {\n  overflow: hidden;\n}\n\n.appnav.r-seller-nav-sidebar > .seller-nav-sidebar {\n  height: 100%;\n}\n\n/**\n * Palette matches ul.appnav in public/css/index.css: the sidebar is deliberately the same dark\n * green in both light and dark themes, so these are literal values rather than --color-* tokens.\n * `.seller-nav-sidebar--red` (set by SellerNavSidebar.jsx when `channel.isRed`) overrides these to the\n * dashboard_red.css palette below, including its own [data-theme=\"dark\"] variant.\n */\n.seller-nav-sidebar {\n  --seller-nav-bg: #263934;\n  --seller-nav-bg-deep: #1d2e23;\n  --seller-nav-bg-panel: #21322d;\n  --seller-nav-accent: #74bb50;\n  --seller-nav-accent-rgb: 116, 187, 80;\n  --seller-nav-text: #fff;\n  --seller-nav-text-secondary: rgba(255, 255, 255, 0.62);\n  --seller-nav-border: rgba(255, 255, 255, 0.09);\n\n  display: flex;\n  flex-direction: column;\n  background: var(--seller-nav-bg);\n  color: var(--seller-nav-text);\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n/* Mayhem Red: mirrors public/css/dashboard_red.css's ul.appnav overrides (light and dark). */\n.seller-nav-sidebar--red {\n  --seller-nav-bg: #300900;\n  --seller-nav-bg-deep: #4e0f00;\n  --seller-nav-bg-panel: #3d0c00;\n  --seller-nav-accent: #ca1e00;\n  --seller-nav-accent-rgb: 202, 30, 0;\n}\n\n[data-theme='dark'] .seller-nav-sidebar--red {\n  --seller-nav-bg: #1a0500;\n  --seller-nav-bg-deep: #7a2000;\n  --seller-nav-bg-panel: #401200;\n  --seller-nav-accent: #7a2000;\n  --seller-nav-accent-rgb: 122, 32, 0;\n}\n\n.seller-nav-sidebar--loading {\n  padding: 1rem;\n  color: var(--seller-nav-text-secondary);\n}\n\n.seller-nav-sidebar a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.seller-nav-sidebar :focus-visible {\n  outline: 2px solid var(--seller-nav-accent);\n  outline-offset: -2px;\n}\n\n/* Channel switcher */\n\n.seller-nav-sidebar__channel-switcher {\n  position: relative;\n  border-bottom: 1px solid var(--seller-nav-border);\n}\n\n.seller-nav-sidebar__channel-switcher-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 0.5rem;\n  padding: 0.9rem 1rem;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: inherit;\n  font: inherit;\n  font-weight: 600;\n  text-align: left;\n}\n\n.seller-nav-sidebar__channel-switcher-toggle:hover {\n  background: var(--seller-nav-accent);\n}\n\n.seller-nav-sidebar__channel-switcher-current {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.seller-nav-sidebar__channel-switcher-avatar {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 4px;\n  background: var(--seller-nav-bg-deep);\n  color: var(--seller-nav-accent);\n}\n\n.seller-nav-sidebar__channel-switcher-name {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.seller-nav-sidebar__channel-switcher-arrow {\n  flex-shrink: 0;\n  transition: transform 0.2s;\n}\n\n.seller-nav-sidebar__channel-switcher-toggle[aria-expanded='true'] .seller-nav-sidebar__channel-switcher-arrow {\n  transform: rotate(180deg);\n}\n\n.seller-nav-sidebar__channel-switcher-panel {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  max-height: 300px;\n  overflow-y: auto;\n  background: var(--seller-nav-bg-deep);\n  border-bottom: 1px solid var(--seller-nav-border);\n  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.35);\n}\n\n.seller-nav-sidebar__channel-switcher-group-label {\n  padding: 0.7rem 1rem 0.35rem;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--seller-nav-text-secondary);\n}\n\n.seller-nav-sidebar__channel-switcher-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.seller-nav-sidebar__channel-switcher-list li {\n  margin: 0;\n  padding: 0;\n}\n\n.seller-nav-sidebar__channel-switcher-list a {\n  display: block;\n  padding: 0.5rem 1rem;\n}\n\n.seller-nav-sidebar__channel-switcher-list a:hover {\n  background: var(--seller-nav-accent);\n}\n\n.seller-nav-sidebar__channel-switcher-loading,\n.seller-nav-sidebar__channel-switcher-empty {\n  padding: 1rem;\n  text-align: center;\n  font-size: 13px;\n  color: var(--seller-nav-text-secondary);\n}\n\n/* Search */\n\n.seller-nav-sidebar__search {\n  position: relative;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--seller-nav-border);\n}\n\n.seller-nav-sidebar__search-input {\n  width: 100%;\n  padding: 0.5rem 0.65rem;\n  border: 1px solid var(--seller-nav-border);\n  border-radius: 4px;\n  font: inherit;\n  background: var(--seller-nav-bg-deep);\n  color: var(--seller-nav-text);\n}\n\n.seller-nav-sidebar__search-input:focus {\n  outline: none;\n  border-color: var(--seller-nav-accent);\n  box-shadow: 0 0 0 2px rgba(var(--seller-nav-accent-rgb), 0.28);\n}\n\n.seller-nav-sidebar__search-input::placeholder {\n  color: var(--seller-nav-text-secondary);\n}\n\n.seller-nav-sidebar__search-result-count {\n  position: absolute;\n  top: 1.4rem;\n  right: 1.6rem;\n  font-size: 11px;\n  color: var(--seller-nav-text-secondary);\n  pointer-events: none;\n}\n\n/* Help articles search widget */\n\n.seller-nav-help-articles {\n  border-bottom: 1px solid var(--seller-nav-border);\n  background: var(--seller-nav-bg-panel);\n}\n\n.seller-nav-help-articles__header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.6rem 1rem 0.4rem;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--seller-nav-text-secondary);\n  border-bottom: 1px solid var(--seller-nav-border);\n}\n\n.seller-nav-help-articles__icon {\n  color: var(--seller-nav-accent);\n  font-size: 12px;\n}\n\n.seller-nav-help-articles__loading-indicator {\n  margin-left: auto;\n  font-size: 14px;\n  line-height: 1;\n  color: var(--seller-nav-accent);\n}\n\n.seller-nav-help-articles__status {\n  padding: 0.6rem 1rem;\n  font-size: 12px;\n  color: var(--seller-nav-text-secondary);\n  font-style: italic;\n}\n\n.seller-nav-help-articles__status--error {\n  color: #e57373;\n}\n\n.seller-nav-help-articles__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.seller-nav-help-articles__item {\n  margin: 0;\n  padding: 0;\n  border-bottom: 1px solid var(--seller-nav-border);\n}\n\n.seller-nav-help-articles__item:last-child {\n  border-bottom: none;\n}\n\n.seller-nav-help-articles__link {\n  display: block;\n  padding: 0.55rem 1rem;\n  text-decoration: none;\n  color: inherit;\n  transition: background-color 0.15s ease;\n}\n\n.seller-nav-help-articles__link:hover {\n  background: var(--seller-nav-accent);\n  color: var(--seller-nav-text);\n}\n\n.seller-nav-help-articles__item-title {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: var(--seller-nav-text);\n}\n\n.seller-nav-help-articles__link:hover .seller-nav-help-articles__item-title {\n  color: var(--seller-nav-text);\n}\n\n.seller-nav-help-articles__item-subtitle {\n  display: block;\n  font-size: 11px;\n  line-height: 1.35;\n  color: var(--seller-nav-text-secondary);\n  margin-top: 0.15rem;\n}\n\n.seller-nav-help-articles__link:hover .seller-nav-help-articles__item-subtitle {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n/* Sections */\n\n.seller-nav-sidebar__sections {\n  flex: 1;\n  overflow-y: auto;\n}\n\n/**\n * A pinned section renders SellerNavItem rows directly, with no accordion header. They sit at\n * the sidebar's top level, so they're restyled to read as peers of the section headers rather\n * than as items nested inside one: sidebar ground, accent icon, heavier title.\n */\n.seller-nav-sidebar__pinned {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  background: var(--seller-nav-bg);\n  border-bottom: 1px solid var(--seller-nav-border);\n}\n\n.seller-nav-sidebar__pinned .seller-nav-item {\n  border-top: none;\n}\n\n.seller-nav-sidebar__pinned .seller-nav-item__link {\n  padding: 0.75rem 1rem;\n}\n\n.seller-nav-sidebar__pinned .seller-nav-item__icon {\n  width: 20px;\n  color: var(--seller-nav-accent);\n}\n\n.seller-nav-sidebar__pinned .seller-nav-item__row:hover .seller-nav-item__icon {\n  color: var(--seller-nav-text);\n}\n\n.seller-nav-sidebar__pinned .seller-nav-item__text strong {\n  font-weight: 600;\n}\n\n.seller-nav-section {\n  border-bottom: 1px solid var(--seller-nav-border);\n}\n\n.seller-nav-section__toggle {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  background: transparent;\n  border: none;\n  border-left: 3px solid transparent;\n  cursor: pointer;\n  color: inherit;\n  font: inherit;\n  font-weight: 600;\n  text-align: left;\n}\n\n.seller-nav-section__toggle:hover {\n  background: var(--seller-nav-accent);\n}\n\n.seller-nav-section--expanded .seller-nav-section__toggle {\n  background: var(--seller-nav-bg-deep);\n}\n\n.seller-nav-section--active-trail .seller-nav-section__toggle {\n  border-left-color: var(--seller-nav-accent);\n}\n\n.seller-nav-section__icon {\n  flex-shrink: 0;\n  width: 20px;\n  text-align: center;\n  color: var(--seller-nav-accent);\n}\n\n.seller-nav-section__toggle:hover .seller-nav-section__icon {\n  color: var(--seller-nav-text);\n}\n\n.seller-nav-section__title {\n  flex: 1;\n  min-width: 0;\n}\n\n.seller-nav-section__alert-indicator {\n  flex-shrink: 0;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #f4c542;\n  box-shadow: 0 0 0 2px rgba(244, 197, 66, 0.18);\n}\n\n.seller-nav-section__chevron {\n  flex-shrink: 0;\n  font-size: 12px;\n  color: var(--seller-nav-text-secondary);\n  transition: transform 0.2s;\n}\n\n.seller-nav-section--expanded .seller-nav-section__chevron {\n  transform: rotate(180deg);\n}\n\n.seller-nav-section__items {\n  background: var(--seller-nav-bg-panel);\n}\n\n.seller-nav-section__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/* Items */\n\n.seller-nav-item {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border-top: 1px solid var(--seller-nav-border);\n}\n\n.seller-nav-item__row {\n  display: flex;\n  align-items: stretch;\n  border-left: 3px solid transparent;\n}\n\n.seller-nav-item--active > .seller-nav-item__row {\n  background: var(--seller-nav-bg-deep);\n  border-left-color: var(--seller-nav-accent);\n}\n\n.seller-nav-item__link {\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  align-items: flex-start;\n  gap: 0.7rem;\n  padding: 0.6rem 1rem;\n}\n\n.seller-nav-item__row:hover {\n  background: var(--seller-nav-accent);\n}\n\n.seller-nav-item__icon {\n  flex-shrink: 0;\n  width: 18px;\n  text-align: center;\n  margin-top: 2px;\n  color: var(--seller-nav-text-secondary);\n}\n\n.seller-nav-item__row:hover .seller-nav-item__icon,\n.seller-nav-item--active .seller-nav-item__icon {\n  color: var(--seller-nav-text);\n}\n\n.seller-nav-item__text {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n  gap: 0.15rem;\n}\n\n.seller-nav-item__text strong {\n  font-weight: 500;\n}\n\n.seller-nav-item__title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.seller-nav-item__count-badge {\n  flex-shrink: 0;\n  min-width: 1.35rem;\n  padding: 0.05rem 0.35rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.14);\n  color: var(--seller-nav-text);\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1.35;\n  text-align: center;\n}\n\n.seller-nav-item__count-badge--updated {\n  background: #f4c542;\n  color: #1d2e23;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1.35;\n  text-align: center;\n}\n\n.seller-nav-item__description {\n  font-size: 12px;\n  line-height: 1.35;\n  color: var(--seller-nav-text-secondary);\n}\n\n.seller-nav-item__row:hover .seller-nav-item__description {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.seller-nav-item__disclosure {\n  flex-shrink: 0;\n  width: 34px;\n  background: transparent;\n  border: none;\n  border-left: 1px solid var(--seller-nav-border);\n  color: var(--seller-nav-text-secondary);\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.seller-nav-item__disclosure:hover {\n  color: var(--seller-nav-text);\n}\n\n.seller-nav-item__disclosure i {\n  display: inline-block;\n  transition: transform 0.2s;\n}\n\n.seller-nav-item__disclosure[aria-expanded='true'] i {\n  transform: rotate(180deg);\n}\n\n/* Children */\n\n.seller-nav-item__children,\n.seller-nav-item__contextual-notes {\n  list-style: none;\n  margin: 0;\n  padding: 0.15rem 0 0.4rem 2.1rem;\n  background: var(--seller-nav-bg-deep);\n}\n\n.seller-nav-item__child {\n  margin: 0;\n  padding: 0;\n  border-left: 2px solid var(--seller-nav-border);\n}\n\n.seller-nav-item__child--active {\n  border-left-color: var(--seller-nav-accent);\n  background: rgba(var(--seller-nav-accent-rgb), 0.14);\n}\n\n.seller-nav-item__child--dimmed {\n  opacity: 0.45;\n}\n\n.seller-nav-item__child-link {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.6rem;\n  padding: 0.4rem 1rem 0.4rem 0.7rem;\n}\n\n.seller-nav-item__child-link:hover {\n  background: var(--seller-nav-accent);\n}\n\n.seller-nav-item__child-icon {\n  flex-shrink: 0;\n  width: 16px;\n  margin-top: 2px;\n  text-align: center;\n  font-size: 12px;\n  color: var(--seller-nav-text-secondary);\n}\n\n.seller-nav-item__child-link:hover .seller-nav-item__child-icon {\n  color: var(--seller-nav-text);\n}\n\n.seller-nav-item__child-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  gap: 0.1rem;\n}\n\n.seller-nav-item__child-text strong {\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.seller-nav-item__child-description {\n  font-size: 11px;\n  line-height: 1.35;\n  color: var(--seller-nav-text-secondary);\n}\n\n.seller-nav-item__child-link:hover .seller-nav-item__child-description {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.seller-nav-item__contextual-note {\n  margin: 0;\n  padding: 0;\n}\n\n.seller-nav-item__contextual-note span {\n  display: block;\n  padding: 0.3rem 1rem 0.3rem 0.7rem;\n  font-size: 12px;\n  color: var(--seller-nav-text-secondary);\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n.seller-nav-sidebar mark {\n  background: var(--seller-nav-accent);\n  color: var(--seller-nav-bg-deep);\n  padding: 0 2px;\n  border-radius: 2px;\n}\n\n/* Footer controls */\n\n.seller-nav-sidebar__footer {\n  display: flex;\n  border-top: 1px solid var(--seller-nav-border);\n  background: var(--seller-nav-bg-deep);\n}\n\n/* Equal thirds, each stacking icon over label so all three fit on one row. */\n.seller-nav-sidebar__footer-control {\n  display: flex;\n  flex: 1 1 0;\n  min-width: 0;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.3rem;\n  padding: 0.6rem 0.35rem;\n  background: transparent;\n  border: none;\n  border-left: 1px solid var(--seller-nav-border);\n  color: inherit;\n  font: inherit;\n  text-align: center;\n}\n\n.seller-nav-sidebar__footer-control:first-child {\n  border-left: none;\n}\n\nbutton.seller-nav-sidebar__footer-control,\na.seller-nav-sidebar__footer-control {\n  cursor: pointer;\n}\n\nbutton.seller-nav-sidebar__footer-control:hover,\na.seller-nav-sidebar__footer-control:hover {\n  background: var(--seller-nav-accent);\n}\n\n/**\n * The icon and label bands are fixed-height and center their contents, so all three cells share\n * a baseline regardless of what fills them: FontAwesome glyphs differ in height, and the\n * language <select> is a bordered box while its neighbors are bare text.\n */\n.seller-nav-sidebar__footer-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 18px;\n  font-size: 14px;\n  line-height: 1;\n  color: var(--seller-nav-text-secondary);\n}\n\nbutton.seller-nav-sidebar__footer-control:hover .seller-nav-sidebar__footer-icon,\na.seller-nav-sidebar__footer-control:hover .seller-nav-sidebar__footer-icon {\n  color: var(--seller-nav-text);\n}\n\n.seller-nav-sidebar__footer-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 22px;\n  font-size: 11px;\n  line-height: 1.2;\n}\n\n/* Not flex-centered: a <select>'s text is laid out by the browser, which centers it within an\n   explicit height once the vertical padding is out of the way. */\n.seller-nav-sidebar__footer-select {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  height: 22px;\n  padding: 0 0.15rem;\n  border: 1px solid var(--seller-nav-border);\n  border-radius: 3px;\n  background: var(--seller-nav-bg);\n  color: var(--seller-nav-text);\n  font: inherit;\n  font-size: 11px;\n  line-height: 1.2;\n  text-align: center;\n}\n\n.seller-nav-sidebar__footer-select:disabled {\n  cursor: not-allowed;\n  opacity: 0.75;\n}\n\n/**\n * \"Minimize Menu\" closes the shared .appnav mobile drawer (see closeMobileNav() in\n * SellerNavFooter.jsx) and replaces the legacy .sidebar-launcher hamburger as the close\n * affordance while the drawer is open. It only makes sense on the same mobile drawer layout as\n * public/css/index.css's `.appnav` rules, so it stays hidden until that breakpoint (800px) and is\n * otherwise invisible on desktop, where the sidebar is always open and pinned.\n */\n.seller-nav-sidebar__footer-minimize {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.55rem 0.5rem;\n  background: transparent;\n  border: none;\n  border-top: 1px solid var(--seller-nav-border);\n  color: var(--seller-nav-text-secondary);\n  font: inherit;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.seller-nav-sidebar__footer-minimize:hover {\n  background: var(--seller-nav-accent);\n  color: var(--seller-nav-text);\n}\n\n@media screen and (max-width: 800px) {\n  .seller-nav-sidebar__footer-minimize {\n    display: flex;\n  }\n\n  /* public/css/index.css reserves 100px of bottom padding on `.appnav` (and `ul.helpnav`) in the\n     mobile drawer so the floating .sidebar-launcher button doesn't overlap the last nav link.\n     The seller sidebar has its own in-drawer footer ending in the minimize control instead, so\n     that reserved space just reads as dead space below it. Collapse it back to 0, scoped to\n     .r-seller-nav-sidebar (this component's mount point) so ul.helpnav and any non-React .appnav\n     fallback keep their original padding. */\n  .appnav.r-seller-nav-sidebar {\n    padding-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
